'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import URElement1 from '@/components/URElement1';
import FAQSection from '@/components/FAQSection';
import { universalRoundFaqs } from '@/data/faqData';

const UniversalRoundPage = () => {
  return (
    <>
      <Header />
      <div className="header-gap-creator"></div>
      <main>
        <Breadcrumbs items={[{ label: 'Universal Filters' }, { label: 'Universal Round' }]} />
        <div className="container-0">
          <URElement1 />
          <FAQSection faqs={universalRoundFaqs} title="FAQs About Round Air Filters" boldAnswer />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default UniversalRoundPage;
